module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#close",
      toString: function () {
        return this.url;
      }
    }